export default "__VITE_ASSET__B6ZQ2Lab__"